import type {JSONValue} from 'types';
import {getOffset} from 'services/utils/getOffset';
import type {AgentWorksSearchProps, SearchProps} from '../types';
import agentWorksQuery from '../data/agentWorksQuery.json';

const WORK_INDEX = 'ebs-work-alias';
const NESTED_PATHS = ['expressions.manifestations', 'dewey'];

const mapSort = (
  sortField: string,
  sortOrder: 'asc' | 'desc',
): Record<string, JSONValue> => {
  const nestedPath = NESTED_PATHS.find(p => sortField.startsWith(`${p}.`));

  return nestedPath
    ? {
        [sortField]: {
          order: sortOrder,
          missing: '_last',
          mode: sortOrder === 'asc' ? 'min' : 'max',
          nested: {path: nestedPath},
        },
      }
    : {[sortField]: sortOrder};
};

export const mapAgentWorksSearchPropsToSearchProps = ({
  agentId,
  page,
  size,
  sortField,
  sortOrder,
  abortSignal,
}: AgentWorksSearchProps): SearchProps => {
  const from = getOffset(page, size);

  const defaultSort = {
    'expressions.manifestations.publishedYear': {
      missing: '_last',
      order: 'desc',
      mode: 'max',
      nested: {
        path: 'expressions.manifestations',
      },
      unmapped_type: 'string',
    },
  };

  const sort = sortField
    ? [mapSort(sortField, sortOrder ?? 'desc'), defaultSort]
    : [defaultSort];

  const elasticBody = JSON.parse(
    JSON.stringify(agentWorksQuery)
      .replaceAll('${QUERY_PLACEHOLDER}', agentId)
      .replaceAll('"${FROM_PLACEHOLDER}"', String(from))
      .replaceAll('"${SIZE_PLACEHOLDER}"', String(size))
      .replaceAll('"${SORT_PLACEHOLDER}"', JSON.stringify(sort)),
  ) as JSONValue;

  return {
    target: '_search',
    index: WORK_INDEX,
    elasticBody,
    abortSignal,
  };
};
